import React from 'react';
import {useState} from 'react';
import {useSelector} from 'react-redux';
import {useEffect} from 'react';
import {useRef} from 'react';
import Moment from 'react-moment';

// react-bootstrap components
import {
  Button,
  Card,
  Row,
  Col,
} from 'react-bootstrap';
import FullCalendar from '@fullcalendar/react';
import timeGridPlugin from '@fullcalendar/timegrid';
import axios from 'components/Axios/Axios.js';
import dayGridPlugin from '@fullcalendar/daygrid';
import DNS from 'components/DNS/dns.js';
import frLocale from 'date-fns/locale/fr';
import enLocale from 'date-fns/locale/en-US';
import {LocalizationProvider} from '@mui/x-date-pickers';
import {AdapterDateFns} from '@mui/x-date-pickers/AdapterDateFns';
import AsyncExcel from 'components/excelExport';

import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import {isMobile, isTablet} from 'react-device-detect';
// import {DateRange} from 'react-date-range';

// import {fr, enUS} from 'react-date-range/src/locale/index';
import ModalADDReservation from './modalADD';
import ModalEDITReservation from './modalEDIT';
import ModalVIEWDELETEReservation from './modalVIEWDELETE';
import moment from 'moment';
import {useTranslation} from 'react-i18next';
import {DesktopDatePicker} from '@mui/x-date-pickers';
import {translations} from '../../i18n/translations';
import TextField from '@mui/material/TextField';
import {Popper} from '@mui/material';

// import DatePickerComponent from 'components/DateTime/DatePicker';

/**
 * This function handle all the event and style in the reservation page.
 * @function Reservations
 * @return {HTML} the reservation's page.
 */
function Reservations() {
  const {t} = useTranslation();
  const token = useSelector((state) => state.token);
  const currentBuilding = useSelector((state) => state.currentBuilding);
  const user = useSelector((state) => state.user);
  const animatedComponents = makeAnimated();

  const [showEventTitle, setEventTitle] = useState('');
  const [showReserved, setReserved] = useState([{name: 'Choisir...'}]);
  const [showEventName, setEventName] = useState('');
  const [searchTerm, setSearchTerm] = useState('');

  const [showSalle, setSalle] = useState([]);
  const [showSalleValue, setSalleValue] = useState([]);
  const [showSalleValueSelected, setSalleValueSelected] = useState([]);
  const [showSalleSelected, setSalleSelected] = useState([]);
  const [showLinkableSalle, setLinkableSalle] = useState([]);
  const [showSelectedLinkableSalle, setSelectedLinkableSalle] = useState([]);
  const [showResPk, setResPk] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [showDisplayDateRange2, setDisplayDateRange2] = useState('none');
  const [isDatePickerOpen, setIsDatePickerOpen] = useState(false);
  const [showNameINResa, setNameINResa] = useState(null);

  {
    /* Modal for Create method */
  }
  const [showTitle, setTitle] = useState('');
  const [showCreatedBy, setCreatedBy] = useState({entreprise: ''});
  const [showDebutDate, setDebutDate] = useState('');
  const [showDebutTime, setDebutTime] = useState('');
  const [showEndTime, setEndTime] = useState('');
  const [showNbUser, setNbUser] = useState('');
  const [showNbExternalUser, setNbExternalUser] = useState('');
  const [selectedDate, setSelectedDate] = useState(new Date());

  // Disposition de la Salle
  const [showSelectedDisposition, setSelectedDisposition] = useState([]);
  const [showValueLinkableSalle, setValueLinkableSalle] = useState([]);
  const [showAllDisposition, setAllDisposition] = useState([]);
  const [showAllDispositionDisplay, setAllDispositionDisplay] = useState([]);
  const [showAllServices, setAllServices] = useState([]);
  const [showAllServicesDisplay, setAllServicesDisplay] = useState([]);
  const [showUserMax, setUserMax] = useState(0);
  const [showUserMaxAll, setUserMaxAll] = useState(0);
  const [showDescription, setDescription] = useState('');
  const [showStartWeekDate, setStartWeekDate] = useState(Date());
  const [showEndWeekDate, setEndWeekDate] = useState(Date());
  const [showFilterEntreprise, setFilterEntreprise] = useState(false);
  const calendarRef = React.createRef(FullCalendar);
  const [showQuotaDefault, setQuotaDefault] = useState(0);
  const [showQuotaDay, setQuotaDay] = useState(0);
  const [showReservedIds, setReservedIds] = useState([]);
  const buttonRef = useRef(null);

  // Room Service
  const [showSelectedRoomService, setSelectedRoomService] = useState([]);

  const [showModal2, setShowModal2] = useState(false);
  {
    /* Modal for View method */
  }
  const [showModal3, setShowModal3] = useState(false);
  {
    /* Modal for EDIT method */
  }
  const [LReservations, setReservations] = useState(
      {
        data: null,
        error: false,
      },
      [],
  );

  const [personalReservations, setpersonalReservations] = useState([]);

  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'token ' + token['tokenRedux'],
    },
  };
  const requestOptionsAxiosGet = {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'token ' + token['tokenRedux'],
    },
  };
  const [showTodayDate, setTodayDate] = useState('');
  const [showMaxdayDate, setMaxdayDate] = useState('');

  const getTodayDate = () => {
    let today = new Date();
    const dd = String(today.getDate()).padStart(2, '0');
    const mm = String(today.getMonth() + 1).padStart(2, '0'); // January is 0!
    const yyyy = today.getFullYear();

    today = yyyy + '-' + mm + '-' + dd;
    const maxday = yyyy + 1 + '-' + mm + '-' + dd;

    setTodayDate(today);
    setMaxdayDate(maxday);
  };


  useEffect(() => {
    const calendarApi = calendarRef.current.getApi();
    const type = moment(calendarApi.getDate());
    const start = type.startOf('week').add(1, 'days').format('YYYY-MM-DD');
    const end = type.endOf('week').add(1, 'days').format('YYYY-MM-DD');
    setStartWeekDate(start);
    setEndWeekDate(end);

    getTodayDate();
    getAllSalle();
    // getReservations(start, end);
    getUserReservations();
  }, []);

  useEffect(() => {
    const checkNameResa = !!user?.user?.vip?.name_resa;
    setNameINResa(checkNameResa);
  }, [user['user'].nameEntreprise]);

  const cleanDataReservation = () => {
    setShowModal(false);
    setShowModal2(false);
    setShowModal3(false);
    setSalleSelected([]);
    setTitle('');
    setDebutDate('');
    setDebutTime('');
    setEndTime('');
    setNbUser('');
    setNbExternalUser('');
    setValueLinkableSalle([]);
    setLinkableSalle([]);
    setSelectedDisposition([]);
    setAllDispositionDisplay([]);
    setSelectedRoomService([]);
    setAllServicesDisplay([]);
    setUserMax(0);
    setUserMaxAll(0);
    setDescription('');
    setReservedIds([]);
  };

  const getAllSalle = () => {
    axios
        .get(
            DNS +
          '/salle/deleteGetPatchSalle/' +
          currentBuilding['currentbuildingRedux'].pk +
          '/',
            requestOptionsAxiosGet,
        )
        .then((response) => {
          setSalle(response.data.fields);
          let tmp = [];
          response.data.fields.map((elem, key) => {
            tmp = tmp.concat({value: elem.pk, label: elem.name});
          });
          setSalleValue(tmp);
        });
  };

  const getSalle = (dates=[], start, end, salleIds = []) => {
    console.log('rfjaghfaz', dates);
    axios
        .post(
            `${DNS}/salle/getSalleAvailable/${currentBuilding['currentbuildingRedux'].pk}/`,
            {
              dates: dates, // array of YYYY-MM-DD strings
              start: start, // string like "09:00"
              end: end, // string like "11:00"
              salleIds: salleIds, // array of integers
            },
            {
              headers: {
                'Content-Type': 'application/json',
                'Authorization': 'token ' + token['tokenRedux'],
              },
            },
        )
        .then((response) => {
          setSalle(response.data.fields);
        })
        .catch((error) => console.log('Error fetching available salles:', error));
  };

  // const getMyCreatedRerservations = (myReservation) => {
  //   let personalReservation = [];
  //   myReservation.map((singleReservation) => {
  //     if (singleReservation.createdBy.pk == user.user.pk) {
  //       personalReservation = personalReservation.concat(singleReservation);
  //     }
  //   });
  //   console.log('personalReservation: ', personalReservation, user.user.pk);
  // };

  const getUserReservations = () => {
    fetch(
        DNS +
        '/salle/GetUserReservation/' +
        currentBuilding['currentbuildingRedux'].pk +
        '/',
        requestOptions,
    ).then(async (response) => {
      const data = await response.json();
      console.log('AAAAAAAAAH', data);
      if (data.fields) {
        console.log(data.fields);
        setpersonalReservations({
          data: data.fields,
          error: false,
        });
        // getMyCreatedRerservations(data.fields);
      } else {
        console.log(data);
        setpersonalReservations({
          data: data.fields,
          error: false,
        });
        // getMyCreatedRerservations(data.fields);
      }
    });
  };

  const getReservations = (startDate, endDate) => {
    fetch(
        DNS +
        '/salle/deleteGetPatchReservation/' +
        currentBuilding['currentbuildingRedux'].pk +
        '/?start=' + startDate + '&end=' + endDate,
        requestOptions,
    ).then(async (response) => {
      const data = await response.json();
      if (data.fields) {
        setReservations({
          data: data.fields,
          error: false,
        });
        // getMyCreatedRerservations(data.fields);
      } else {
        setReservations({
          data: data.fields,
          error: false,
        });
        // getMyCreatedRerservations(data.fields);
      }
      axios.get(DNS + '/users/getQuota/', requestOptionsAxiosGet)
          .then((data) => {
            setQuotaDay(data.data['entreprise'].quotaDay);
            setQuotaDefault(data.data['entreprise'].quotaDefault);
            console.log(data.data['entreprise'].quotaDay, data.data['entreprise'].quotaDefault);
          });
    });
  };

  const headersXLS = [
    {label: 'Titre', key: 'name'},
    {label: 'Commence le', key: 'debutDate'},
    {label: 'de', key: 'debutTime'},
    {label: 'à', key: 'endTime'},
    {label: 'Salle', key: 'reservedSalle'},
    {label: 'Room Service', key: 'WantedService'},
    {label: 'Nombre de Participants', key: 'nbUser'},
    {label: 'Commentaire', key: 'comment'},
  ];

  let content = [];
  let personalcontent = [];

  if (LReservations.error) {
    content = <p>ERROR: couldn't load reservation list properly.</p>;
  }

  if (personalReservations.data) {
    console.log(personalReservations);
    personalcontent = personalReservations.data
        .slice(0)
        .reverse()
        .filter((val) => {
          if (showSalleValueSelected.length != 0) {
            let tmp = false;
            val.reservedSalle.map((elem, key) => {
              showSalleValueSelected.map((e, key) => {
                if (elem.name == e.label) {
                  tmp = true;
                }
              });
            });
            if (tmp == true) {
              if (searchTerm == '') {
                if (showFilterEntreprise && val.createdBy.entreprise.nameEntreprise.toLowerCase() != user['user'].nameEntreprise.toLowerCase()) {
                  return undefined;
                } else {
                  return val;
                }
              } else if (
                val.name.toLowerCase().includes(searchTerm.toLowerCase())
              ) {
                if (showFilterEntreprise && val.createdBy.entreprise.nameEntreprise.toLowerCase() != user['user'].nameEntreprise.toLowerCase()) {
                  return undefined;
                } else {
                  return val;
                }
              } else {
                return undefined;
              }
            }
            return undefined;
          }
          if (searchTerm == '') {
            if (showFilterEntreprise && val.createdBy.entreprise.nameEntreprise.toLowerCase() != user['user'].nameEntreprise.toLowerCase()) {
              return undefined;
            } else {
              return val;
            }
          } else if (val.name.toLowerCase().includes(searchTerm.toLowerCase())) {
            if (showFilterEntreprise && val.createdBy.entreprise.nameEntreprise.toLowerCase() != user['user'].nameEntreprise.toLowerCase()) {
              return undefined;
            } else {
              return val;
            }
          }
        })
        .map((reservation, key) => {
        // setReserved(reservation.reservedSalle[0].name)
          const calendardata = {
            event: {
              id: reservation.pk,
              title: reservation.reservedSalle.map((elem, key) => {
                return (elem.name + ' ');
              }),
              start: reservation.debutDate + 'T' + reservation.debutTime,
              end: reservation.endDate + 'T' + reservation.endTime,
              color: reservation.reservedSalle[0].colorCard,
              extendedProps: {
                description: reservation.name,
                reservpk: reservation.id,
                EnbUserExpected: reservation.nbUserExpected,
                Etitle: reservation.name,
                EdebutDate: reservation.debutDate,
                EdebutTime: reservation.debutTime,
                EendTime: reservation.endTime,
                Ereserved: reservation.reservedSalle,
                createdBy: reservation.createdBy,
                WantedDisposition: reservation.WantedDisposition,
                WantedService: reservation.WantedService,
                comment: reservation.comment,
              },
            },
          };
          return calendardata;
        });
    // console.log(content)
  }

  if (LReservations.data) {
    content = LReservations.data
        .slice(0)
        .reverse()
        .filter((val) => {
          if (showSalleValueSelected.length != 0) {
            let tmp = false;
            val.reservedSalle.map((elem, key) => {
              showSalleValueSelected.map((e, key) => {
                if (elem.name == e.label) {
                  tmp = true;
                }
              });
            });
            if (tmp == true) {
              if (searchTerm == '') {
                if (showFilterEntreprise && val.createdBy.entreprise.nameEntreprise.toLowerCase() != user['user'].nameEntreprise.toLowerCase()) {
                  return undefined;
                } else {
                  return val;
                }
              } else if (
                val.name.toLowerCase().includes(searchTerm.toLowerCase())
              ) {
                if (showFilterEntreprise && val.createdBy.entreprise.nameEntreprise.toLowerCase() != user['user'].nameEntreprise.toLowerCase()) {
                  return undefined;
                } else {
                  return val;
                }
              } else {
                return undefined;
              }
            }
            return undefined;
          }
          if (searchTerm == '') {
            if (showFilterEntreprise && val.createdBy.entreprise.nameEntreprise.toLowerCase() != user['user'].nameEntreprise.toLowerCase()) {
              return undefined;
            } else {
              return val;
            }
          } else if (val.name.toLowerCase().includes(searchTerm.toLowerCase())) {
            if (showFilterEntreprise && val.createdBy.entreprise.nameEntreprise.toLowerCase() != user['user'].nameEntreprise.toLowerCase()) {
              return undefined;
            } else {
              return val;
            }
          }
        })
        .map((reservation, key) => {
        // setReserved(reservation.reservedSalle[0].name)
          const calendardata = {
            id: reservation.pk,
            title: reservation.reservedSalle.map((elem, key) => {
              return (elem.name + ' ');
            }),
            start: reservation.debutDate + 'T' + reservation.debutTime,
            end: reservation.endDate + 'T' + reservation.endTime,
            color: reservation.reservedSalle[0].colorCard,
            extendedProps: {
              description: reservation.name,
              reservpk: reservation.id,
              EnbUserExpected: reservation.nbUserExpected,
              ExternalUserExpected: reservation.externalUsers,
              Etitle: reservation.name,
              EdebutDate: reservation.debutDate,
              EdebutTime: reservation.debutTime,
              EendTime: reservation.endTime,
              Ereserved: reservation.reservedSalle,
              createdBy: reservation.createdBy,
              ShowNameCreatedBy: reservation.createdBy.entreprise?.vip_entreprise?.name_resa,
              WantedDisposition: reservation.WantedDisposition,
              WantedService: reservation.WantedService,
              comment: reservation.comment,
            },
          };
          return calendardata;
        });
    // console.log(content)
  }

  const handleDateClick = (arg) => {
    // bind with an arrow function
    cleanDataReservation();
    setEventTitle(arg.event.title);
    setEventName(arg.event.extendedProps.description);
    setTitle(arg.event.extendedProps.Etitle);
    setNbUser(arg.event.extendedProps.EnbUserExpected);
    setNbExternalUser(arg.event.extendedProps.ExternalUserExpected);
    setDebutDate([[arg.event.extendedProps.EdebutDate, arg.event.extendedProps.EdebutDate]]);
    setDebutTime(arg.event.extendedProps.EdebutTime);
    setEndTime(arg.event.extendedProps.EendTime);
    setResPk(arg.event.extendedProps.reservpk);
    setShowModal2(true);
    setCreatedBy(arg.event.extendedProps.createdBy);
    setNameINResa(arg.event.extendedProps.ShowNameCreatedBy);
    setReserved(arg.event.extendedProps.Ereserved);
    const salleIds = [];
    arg.event.extendedProps.Ereserved.map((elem, key) => {
      salleIds.push(elem.pk);
    });
    setReservedIds(salleIds);
    setSalleSelected(arg.event.extendedProps.Ereserved[0].name);
    setDescription(arg.event.extendedProps.comment);
    arg.event.extendedProps.Ereserved[0]['value'] =
      arg.event.extendedProps.Ereserved[0].name;
    dropdownLinkableSalle(arg.event.extendedProps.Ereserved[0]);
    let test = [];
    let tmp = [];
    arg.event.extendedProps.Ereserved.map((value, key) => {
      if (key != 0) {
        test = test.concat(value.name);
      }
    });
    let tmp2 = [];
    arg.event.extendedProps.Ereserved[0].linkSalle.map((elem, key) => {
      tmp2 = tmp2.concat({value: elem.id, label: elem.name});
      if (test.includes(elem.name) == true) {
        tmp = tmp.concat({value: elem.id, label: elem.name});
      }
    });
    setSelectedLinkableSalle(tmp);
    handleSalleCombinable(tmp);
    setLinkableSalle(tmp2);
    let AllDispositionsTab = [];
    let AllServicesTab = [];
    arg.event.extendedProps.Ereserved[0].AllDispositions.split(' ').map(
        (elem, key) => {
          AllDispositionsTab = AllDispositionsTab.concat({
            value: key,
            label: elem,
          });
        },
    );
    arg.event.extendedProps.Ereserved[0].AllServices.split(' ').map(
        (elem, key) => {
          AllServicesTab = AllServicesTab.concat({value: key, label: elem});
        },
    );
    setAllDisposition(AllDispositionsTab);
    setAllServices(AllServicesTab);

    tmp = [];
    arg.event.extendedProps.Ereserved.map((value, key) => {
      if (key != 0) {
        tmp = tmp.concat(value.AllServices);
      }
    });
    let listOfServices = [];
    tmp.map((elem) => {
      elem.split(' ').map((value) => {
        value == 'None' ?
          null :
          (listOfServices = listOfServices.concat(value));
      });
    });
    if (listOfServices.length == 0) {
      listOfServices = listOfServices.concat('None');
      setAllServicesDisplay(AllServicesTab);
      let newValue = [];
      AllServicesTab.map((elem) => {
        arg.event.extendedProps.WantedService.split(' ').map((value) => {
          elem.label == value ? (newValue = newValue.concat(elem)) : null;
        });
      });
      setSelectedRoomService(newValue);
    } else {
      AllServicesTab.map((elem, key) => {
        if (!listOfServices.includes(elem.label)) {
          listOfServices = listOfServices.concat(elem.label);
        }
      });
      tmp = [];
      listOfServices.map((elem, key) => {
        tmp = tmp.concat({value: key, label: elem});
      });
      setAllServicesDisplay(tmp);
      let trueValue = [];
      tmp.map((elem) =>
        arg.event.extendedProps.WantedService.split(' ').map((elem2) => {
          elem.label == elem2 ?
          (trueValue = trueValue.concat(elem)) :
          null;
        }),
      );
      setSelectedRoomService(trueValue);
    }

    tmp = [];
    arg.event.extendedProps.Ereserved.map((value, key) => {
      if (key != 0) {
        tmp = tmp.concat(value.AllDispositions);
      }
    });
    let listOfDisposition = [];
    tmp.map((elem) => {
      elem.split(' ').map((value) => {
        value == 'None' ?
          null :
          (listOfDisposition = listOfDisposition.concat(value));
      });
    });
    if (listOfDisposition.length == 0) {
      listOfDisposition = listOfDisposition.concat('None');
      setAllDispositionDisplay(AllDispositionsTab);
      AllDispositionsTab.map((elem) =>
        elem.label == arg.event.extendedProps.WantedDisposition ?
          setSelectedDisposition(elem) :
          null,
      );
    } else {
      AllDispositionsTab.map((elem, key) => {
        if (!listOfDisposition.includes(elem.label)) {
          listOfDisposition = listOfDisposition.concat(elem.label);
        }
      });
      tmp = [];
      listOfDisposition.map((elem, key) => {
        tmp = tmp.concat({value: key, label: elem});
      });
      setAllDispositionDisplay(tmp);
      tmp.map((elem) =>
        elem.label == arg.event.extendedProps.WantedDisposition ?
          setSelectedDisposition(elem) :
          null,
      );
    }
  };

  const goToSpecificDate = (dateString) => {
    console.log('triggered');
    if (calendarRef.current) {
      const calendarApi = calendarRef.current.getApi();
      calendarApi.gotoDate(dateString); // Déplace le calendrier à la date donnée
      const type = moment(calendarApi.getDate());
      const date2 = moment(showEndWeekDate);
      if (type > date2) {
        const start = type.startOf('week').add(1, 'days').format('YYYY-MM-DD');
        const end = type.endOf('week').add(1, 'days').format('YYYY-MM-DD');
        setStartWeekDate(start);
        setEndWeekDate(end);
        getReservations(start, end);
      } else if (type < date2) {
        const start = type.startOf('week').add(1, 'days').format('YYYY-MM-DD');
        const end = type.endOf('week').add(1, 'days').format('YYYY-MM-DD');
        setStartWeekDate(start);
        setEndWeekDate(end);
        getReservations(start, end);
      }
    }
  };

  const dropdownLinkableSalle = (e) => {
    setSelectedDisposition([]);
    setSelectedRoomService([]);
    setValueLinkableSalle(null);
    let tmp = [];
    let AllDispositionsTab = [];
    let AllServicesTab = [];
    showSalle.map((value, key) => {
      value.name === e.value ?
        ((tmp = value.linkSalle),
        value.AllDispositions.split(' ').map((elem, key) => {
          AllDispositionsTab = AllDispositionsTab.concat({
            value: key,
            label: elem,
          });
        }),
        value.AllServices.split(' ').map((elem, key) => {
          AllServicesTab = AllServicesTab.concat({value: key, label: elem});
        }),
        setUserMax(value.nbUserMax),
        setUserMaxAll(value.nbUserMax)) :
        null;
    });
    setAllDisposition(AllDispositionsTab);
    setAllDispositionDisplay(AllDispositionsTab);
    setAllServices(AllServicesTab);
    setAllServicesDisplay(AllServicesTab);
    let concatTmp = [];
    tmp.map(
        (value, key) =>
          (concatTmp = concatTmp.concat({value: value.id, label: value.name})),
    );
    setLinkableSalle(concatTmp);

    tmp = [];
  };

  const handleSalleCombinable = (e) => {
    setSelectedDisposition([]);
    setSelectedRoomService([]);
    setValueLinkableSalle(e);
    setSelectedLinkableSalle(e);
    let nbMax = 0;
    let tmp = [];
    showSalle.map((value, key) => {
      e.map((elem, nb) => {
        value.name == elem.label ?
          ((tmp = tmp.concat(value.AllServices)),
          (nbMax = nbMax + value.nbUserMax)) :
          null;
      });
    });
    setUserMaxAll(showUserMax + nbMax);
    let listOfServices = [];
    tmp.map((elem) => {
      elem.split(' ').map((value) => {
        value == 'None' ?
          null :
          (listOfServices = listOfServices.concat(value));
      });
    });
    if (listOfServices.length == 0) {
      listOfServices = listOfServices.concat('None');
      setAllServicesDisplay(showAllServices);
    } else {
      showAllServices.map((elem, key) => {
        if (!listOfServices.includes(elem.label)) {
          listOfServices = listOfServices.concat(elem.label);
        }
      });
      tmp = [];
      listOfServices.map((elem, key) => {
        tmp = tmp.concat({value: key, label: elem});
      });
      setAllServicesDisplay(tmp);
    }

    tmp = [];
    showSalle.map((value, key) => {
      e.map((elem, nb) => {
        value.name == elem.label ?
          (tmp = tmp.concat(value.AllDispositions)) :
          null;
      });
    });
    let listOfDispositions = [];
    tmp.map((elem) => {
      elem.split(' ').map((value) => {
        value == 'None' ?
          null :
          (listOfDispositions = listOfDispositions.concat(value));
      });
    });
    if (listOfDispositions.length == 0) {
      listOfDispositions = listOfDispositions.concat('None');
      setAllDispositionDisplay(showAllDisposition);
    } else {
      showAllDisposition.map((elem, key) => {
        if (!listOfDispositions.includes(elem.label)) {
          listOfDispositions = listOfDispositions.concat(elem.label);
        }
      });
      tmp = [];
      listOfDispositions.map((elem, key) => {
        tmp = tmp.concat({value: key, label: elem});
      });
      setAllDispositionDisplay(tmp);
    }
  };

  const fillDictWithValue = () => {
    return ({
      'showSalleSelected': showSalleSelected,
      'setSalleSelected': setSalleSelected,
      'showLinkableSalle': showLinkableSalle,
      'setLinkableSalle': setLinkableSalle,
      'showSelectedLinkableSalle': showSelectedLinkableSalle,
      'setSelectedLinkableSalle': setSelectedLinkableSalle,
      'showTitle': showTitle,
      'setTitle': setTitle,
      'showDebutDate': showDebutDate,
      'setDebutDate': setDebutDate,
      'showDebutTime': showDebutTime,
      'setDebutTime': setDebutTime,
      'showEndTime': showEndTime,
      'setEndTime': setEndTime,
      'showSelectedDisposition': showSelectedDisposition,
      'setSelectedDisposition': setSelectedDisposition,
      'showValueLinkableSalle': showValueLinkableSalle,
      'setValueLinkableSalle': setValueLinkableSalle,
      'showAllDisposition': showAllDisposition,
      'setAllDisposition': setAllDisposition,
      'showAllDispositionDisplay': showAllDispositionDisplay,
      'setAllDispositionDisplay': setAllDispositionDisplay,
      'showAllServices': showAllServices,
      'setAllServices': setAllServices,
      'showAllServicesDisplay': showAllServicesDisplay,
      'setAllServicesDisplay': setAllServicesDisplay,
      'showUserMax': showUserMax,
      'setUserMax': setUserMax,
      'showUserMaxAll': showUserMaxAll,
      'setUserMaxAll': setUserMaxAll,
      'showDescription': showDescription,
      'setDescription': setDescription,
      'showSelectedRoomService': showSelectedRoomService,
      'setSelectedRoomService': setSelectedRoomService,
      'showNbUser': showNbUser,
      'setNbUser': setNbUser,
      'showNbExternalUser': showNbExternalUser,
      'setNbExternalUser': setNbExternalUser,
      'showReserved': showReserved,
      'showSalle': showSalle,
      'showResPk': showResPk,
    });
  };

  return (
    <>
      <Row>
        <Col md="10">
          <Card>
            <Card.Header>
              {!isMobile ?
                    <Card.Title as="h4">{t(translations.MEETING_BLOCK_TITLE)}</Card.Title> :
                    <Card.Title as="h4" className={'text-center'}>{t(translations.MEETING_BLOCK_TITLE)}</Card.Title>
              }

              <p className="card-category d-none d-sm-block">{t(translations.MEETING_SUBTITLE3)}</p>
              <div className="row pl-0 pr-0" style={{paddingTop: '15px'}}>
                {user['user'].role != 'collab' ? (
                  <Button
                    id="Ajouter"
                    className={'col-sm-12 col-12 col-md-3 col-lg-3 mr-3'}
                    onClick={() => {
                      getSalle();
                      cleanDataReservation();
                      setShowModal(true);
                    }}
                  >
                    {t(translations.MEETING_BUTTON)}
                  </Button>) :
                  null }
                <Button
                  id="Mes réservations"
                  className={'col-sm-12 col-12 col-md-2 col-lg-2 mr-3'}
                  onClick={() => {
                    setFilterEntreprise(!showFilterEntreprise);
                  }}
                >
                  {showFilterEntreprise ? t(translations.MEETING_BUTTON2) : t(translations.MEETING_BUTTON3)}
                </Button>
                <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={localStorage.i18nextLng == 'fr' ? frLocale : localStorage.i18nextLng == 'en' ? enLocale : frLocale}>
                  {/* Ternary condition restored */}
                  {showDisplayDateRange2 === 'none' ? (
                    <Button
                      ref={buttonRef}
                      className={'col-sm-12 col-12 col-md-2 col-lg-2 mr-3'}
                      onClick={() => {
                        setDisplayDateRange2('block');
                        setIsDatePickerOpen(true);
                      }}
                    >
                      {t(translations.DATE_BUTTON_OPEN)}
                    </Button>
                  ) : (
                    <Button
                      className={'col-sm-12 col-12 col-md-2 col-lg-2 mr-3'}
                      onClick={() => {
                        setDisplayDateRange2('none');
                        setIsDatePickerOpen(false);
                      }}
                    >
                      {t(translations.DATE_BUTTON_CLOSE)}
                    </Button>
                  )}
                  {/* Popper for dynamic positioning of the date picker */}
                  <Popper
                    open={isDatePickerOpen}
                    anchorEl={buttonRef.current}
                    placement='bottom-start' // Ensures it aligns properly under the button
                    style={{zIndex: 10000}}
                  >
                    <DesktopDatePicker
                      label={t(translations.SELECT_DATE_LABEL)}
                      inputFormat='dd/MM/yyyy'
                      value={selectedDate}
                      open={isDatePickerOpen}
                      onChange={(newDate) => {
                        if (newDate) {
                          setSelectedDate(newDate);
                          goToSpecificDate(newDate);
                        }
                        setIsDatePickerOpen(false); // Close picker after selection
                      }}
                      onClose={() => {
                        setIsDatePickerOpen(false);
                        setDisplayDateRange2('none');
                      }
                      }
                      renderInput={(params) => (
                        <TextField {...params} sx={{backgroundColor: 'white', color: 'black'}} />
                      )}
                    />
                  </Popper>
                </LocalizationProvider>

                {/* <div style={{position: 'absolute'}}>*/}
                <Select
                  placeholder={t(translations.MEETING_SEARCH)}
                  closeMenuOnSelect={false}
                  components={animatedComponents}
                  className="col-sm-12 col-12 col-md-2 col-lg-2 mr-3"
                  isMulti
                  options={showSalleValue}
                  onChange={(e) => setSalleValueSelected(e)}
                />
                <div id="custom-search-input" className="col-sm-12 col-12 col-md-2 col-lg-2 mr-3">
                  <div className="input-group">
                    <input
                      type="text"
                      className="form-control"
                      placeholder={t(translations.SEARCH)}
                      onChange={(event) => {
                        setSearchTerm(event.target.value);
                      }}
                    />
                    <span className="input-group-btn btn btn-warning">
                      <span className="fas fa-search"></span>
                    </span>
                  </div>
                </div>
              </div>


            </Card.Header>
            <Card.Body>
              <FullCalendar
                ref={calendarRef}
                plugins={isMobile ? [timeGridPlugin, dayGridPlugin] : [timeGridPlugin, dayGridPlugin]}
                slotEventOverlap={true}
                height={500}
                eventMaxStack={3}
                nowIndicator={true}
                allDaySlot={false}
                slotDuration={'00:30:00'}
                Duration={'00:00:00'}
                initialView={isMobile && !isTablet ? 'timeGridDay' : 'timeGridWeek'}
                buttonText={{
                  month: t(translations.MONTH),
                  week: t(translations.WEEK),
                  day: t(translations.DAY),
                  list: t(translations.LIST),
                }}
                datesSet={(arg) => {
                  const start = moment(arg.start).format('YYYY-MM-DD');
                  const end = moment(arg.end).format('YYYY-MM-DD');
                  setStartWeekDate(start);
                  setEndWeekDate(end);
                  getReservations(start, end);
                }}
                customButtons={{
                  next: {
                    click: () => {
                      const calendarApi = calendarRef.current.getApi();
                      calendarApi.next();
                      const type = moment(calendarApi.getDate());
                      const date2 = moment(showEndWeekDate);
                      if (type > date2) {
                        const start = type.startOf('week').add(1, 'days').format('YYYY-MM-DD');
                        const end = type.endOf('week').add(1, 'days').format('YYYY-MM-DD');
                        setStartWeekDate(start);
                        setEndWeekDate(end);
                        getReservations(start, end);
                      }
                    },
                  },
                  prev: {
                    click: () => {
                      const calendarApi = calendarRef.current.getApi();
                      calendarApi.prev();
                      const type = moment(calendarApi.getDate());
                      const date2 = moment(showStartWeekDate);
                      if (type < date2) {
                        const start = type.startOf('week').add(1, 'days').format('YYYY-MM-DD');
                        const end = type.endOf('week').add(1, 'days').format('YYYY-MM-DD');
                        setStartWeekDate(start);
                        setEndWeekDate(end);
                        getReservations(start, end);
                      }
                    },
                  },
                }}
                headerToolbar={{
                  start: 'title',
                  center: '',
                  end: isMobile || isTablet ? 'prev,next' : 'timeGridWeek,timeGridDay prev,next',
                }}
                locale={localStorage.i18nextLng == 'fr' ? 'fr' : localStorage.i18nextLng == 'en' ? 'en' : 'fr'}
                eventDisplay="list-item"
                firstDay={1}
                eventClick={handleDateClick}
                events={content}
                navLinks={true}
              />
              {/* ##################################### ADD MODAL BELOW #################################################### */}
              <ModalADDReservation showModal={showModal}
                setShowModal={setShowModal}
                showTodayDate={showTodayDate}
                showMaxdayDate={showMaxdayDate}
                showSalle={showSalle}
                getReservations={getReservations}
                getUserReservations={getUserReservations}
                start={showStartWeekDate}
                end={showEndWeekDate}
                showQuotaDay={showQuotaDay}
                showQuotaDefault={showQuotaDefault}
                getSalle={getSalle}
              />
              {/* ##################################### VIEW DELETE MODAL BELOW #################################################### */}
              <ModalVIEWDELETEReservation
                showModal={showModal2}
                setShowModal={setShowModal2}
                setShowModal3={setShowModal3}
                getReservations={getReservations}
                getUserReservations={getUserReservations}
                showResPk={showResPk}
                showEventTitle={showEventTitle}
                showEventName={showEventName}
                showDebutDate={
                  Array.isArray(showDebutDate) &&
                  showDebutDate.length > 0 &&
                  Array.isArray(showDebutDate[0]) &&
                  showDebutDate[0].length > 0 ?
                    showDebutDate[0][0] :
                    []
                }
                showDebutTime={showDebutTime}
                showEndTime={showEndTime}
                showCreatedBy={showCreatedBy}
                showSelectedDisposition={showSelectedDisposition}
                showSelectedRoomService={showSelectedRoomService}
                showDescription={showDescription}
                start={showStartWeekDate}
                end={showEndWeekDate}
                getSalle={getSalle}
                showReservedIds={showReservedIds}
                showNameINResa={showNameINResa}
              />
              {/* ##################################### EDIT MODAL BELOW #################################################### */}
              <ModalEDITReservation showModalValue={showModal3}
                setShowModal={setShowModal3}
                showTodayDate={showTodayDate}
                showMaxdayDate={showMaxdayDate}
                getReservations={getReservations}
                getUserReservations={getUserReservations}
                fillDictWithValue={fillDictWithValue}
                start={showStartWeekDate}
                end={showEndWeekDate}
                getSalle={getSalle}
                showReservedIds={showReservedIds}
              />
            </Card.Body>
          </Card>
        </Col>
        <Col md={2} style={{marginTop: '3.9%'}}>
          <h3 className="my-3 text-center" style={{color: 'white'}}>{t(translations.MY_FUTURE_RESERVATIONS_TITLE) + ': '}</h3>
          {/* Scrollable container */}
          <style>{`
            .reservation-card-inner {
              transition: transform 0.3s, box-shadow 0.3s, background-color 0.3s;
            }
            .reservation-card-inner:hover {
              cursor: pointer;
              transform: scale(1.04);
              box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
              background-color: rgba(255, 255, 255, 0.1);
            }
          `}</style>
          <div className="my-3 text-center">
            <AsyncExcel
              toExport={personalReservations.data}
              headers={headersXLS}
              sentence="Extraire les données"
            />
          </div>
          <div className="scrollable-table" style={{height: '28.9vh', overflowY: 'auto', border: '2px solid #fff', borderRadius: '4px', padding: '0.5rem', marginBottom: isMobile ? '5%' : '0px'}}>
            <Card className="striped-table-with-hover" style={{color: 'white'}}>
              {personalcontent &&
                personalcontent
                    .slice(0)
                    .sort((obj1, obj2) => new Date(obj1.debutDate) - new Date(obj2.debutDate))
                    .reverse()
                    .map((reservation, index) => {
                      return (
                        <div
                          key={reservation.id}
                          className="reservation-card"
                          style={{height: '180px', width: '100%'}}
                        >
                          <div
                            style={{marginTop: '0%'}}
                            className="card reservation-card-inner"
                            id="id"
                            value={reservation.pk}
                            onClick={() => {
                              handleDateClick(reservation);
                            }}
                          >
                            <div className="row no-gutters align-items-center">
                              <div className="col">
                                <div className="card-body">
                                  <h4 className="nameAppointment">{reservation.event.title}</h4>
                                  <h5 className="dateAppointment">
                                    <i className="fa fa-calendar-check" aria-hidden="true"></i>{' '}
                                    <Moment style={{marginLeft: '7px'}} format="DD/MM/YYYY">
                                      {reservation.event.extendedProps.EdebutDate}
                                    </Moment>
                                  </h5>
                                  <h5 className="dateAppointment">
                                    <i className="fa fa-clock"></i>{' '}
                                    <span style={{marginLeft: '7px'}} className="badge badge-success">
                                      {reservation.event.extendedProps.EdebutTime}
                                    </span>
                                  </h5>
                                  { index < (personalcontent.length - 1) ?
                                  <div style={{marginTop: '10%'}} className="line"></div> :
                                  null
                                  }
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
            </Card>
          </div>
        </Col>
      </Row>
    </>
  );
}

export default Reservations;
